import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=30b0edd1&"
import script from "./TagList.vue?vue&type=script&lang=js&"
export * from "./TagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b0edd1')) {
      api.createRecord('30b0edd1', component.options)
    } else {
      api.reload('30b0edd1', component.options)
    }
    module.hot.accept("./TagList.vue?vue&type=template&id=30b0edd1&", function () {
      api.rerender('30b0edd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/TagList.vue"
export default component.exports